import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { MetaPixel } from './components/MetaPixel';
function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <LandingPage data-id="element-1" />
    </>;
}
export { App };